// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { privateRoutes, RouteWithSubRoutes, RequireLoginRoute } from './routes'
import TopBar from './components/TopBar/TopBar'
import { connect } from 'react-redux'
import NotFound from 'components/notFound'
import auth from 'lib/auth'
import { Layout, Spin, Row, Col } from 'antd'
import Nav from 'components/nav/Nav'
import isDev from 'utils/env'

class App extends React.Component {
  constructor (props) {
    super(props)
    this.privateRoutes = privateRoutes.filter(route => !Boolean(route.hideOnProd) || isDev())
  }

  checkAuth () {
    const expiredAt = auth.getExpiredAt()
    if (expiredAt && Date.now() >= expiredAt) {
      this.props.logOut()
    }
  }

  componentDidMount () {
    const { fetchCityList, isAuthorized, userInfo, logOut } = this.props
    this.checkAuth()
    if (isAuthorized) {
      if (!userInfo) logOut()
      fetchCityList({ silence: true })
    }
  }

  componentDidUpdate () {
    this.checkAuth()
  }

  hasPermission (route) {
    const { roles } = this.props.rbacCurrent
    return (route.roles || []).some(d => !!roles[d])
  }

  renderRbacRoutes () {
    return this.privateRoutes
      .filter(route => this.hasPermission(route))
      .map((r, i) => <RouteWithSubRoutes key={i} {...r} />)
  }

  render () {
    const { menuCollapsed, currentCity } = this.props
    return (
      <RequireLoginRoute>
        <Layout>
          <TopBar />
          <Layout style={{ marginTop: 40, height: 'calc(100vh - 40px)' }}>
            <Layout.Sider
              style={{ background: '#ffffff', borderRight: '1px solid #ccd6dd' }}
              trigger={null}
              collapsible
              collapsed={menuCollapsed}
              collapsedWidth={0}
            >
              <Nav collapsed={menuCollapsed} />
            </Layout.Sider>
            <Layout.Content style={{ flexGrow: 1, backgroundColor: '#FFFFFF' }}>
              {currentCity ? (
                <Switch>
                  {this.renderRbacRoutes()}
                  <Route path='*'>
                    <NotFound />
                  </Route>
                </Switch>
              ) : (
                <Row justify='center' align='middle' style={{ height: '100%' }}>
                  <Col>
                    <Spin />
                  </Col>
                </Row>
              )}
            </Layout.Content>
          </Layout>
        </Layout>
      </RequireLoginRoute>
    )
  }
}

const mapState2Props = ({ loading, rbacCurrent, auth, app, city }) => ({
  isAuthLoading: loading.models.auth,
  rbacCurrent,
  isAuthorized: auth.isAuthorized,
  userInfo: auth.userInfo,
  menuCollapsed: app.menuCollapsed,
  currentCity: city.current
})
const mapDispatch2Props = dispatch => ({
  ...dispatch.auth,
  ...dispatch.city
})

export default connect(mapState2Props, mapDispatch2Props)(App)
